import type {ProductFull} from "@/api/product";
import type {ImageInput} from "@/helpers/imageObject";
import {SeoSchemaProduct} from "@/components/SeoSchema/mode/SeoSchemaProduct";
import {ArticleAuthor, EntityReference, SeoSchemaArticle} from "@/components/SeoSchema/mode/SeoSchemaArticle";

export enum SchemaMode {
    Product = "Product",
    Page = "Page",
    Article = "Article",
}

export interface SeoSchemaProps {
    schema: string | null;
    mode: SchemaMode;
    title: string;
    description: string | null;
    body?: string | null;
    link?: string | null;
    featuredImage?: ImageInput | null;
    datePublished?: string | null;
    dateModified?: string | null;
    image?: ImageInput | ImageInput[] | null;
    product?: ProductFull;
    pageUrl?: string;
    images?: ImageInput[];
    isRelatedTo?: string[];
    articleSection?: string;
    keywords?: string[];
    author?: ArticleAuthor;
    about?: EntityReference[];
}

export function SeoSchema(props: SeoSchemaProps) {
    if (props.schema) {
        return (
            <div dangerouslySetInnerHTML={{__html: props.schema}}></div>
        );
    }
    switch (props.mode) {
        case SchemaMode.Product:
            if (!props.product || !props.pageUrl || !props.images) {
                throw new Error(`[SeoSchema] SchemaMode.Product requires product, pageUrl, and images props.`);
            }
            return <SeoSchemaProduct
                product={props.product}
                pageUrl={props.pageUrl}
                images={props.images}
                description={props.description ?? ""}
                isRelatedTo={props.isRelatedTo}
            />;
        case SchemaMode.Article:
            return <SeoSchemaArticle
                title={props.title}
                description={props.description || props.title}
                body={props.body ?? ""}
                link={props.link ?? ""}
                featuredImage={props.image ?? props.featuredImage ?? ""}
                datePublished={props.datePublished ?? ""}
                dateModified={props.dateModified ?? undefined}
                articleSection={props.articleSection}
                keywords={props.keywords}
                author={props.author}
                about={props.about}
            />;
        case SchemaMode.Page:
            return null;
    }
}
